// Light / dark (owner, 2026-09-24 — idea #27). Default: follow the device's
// own setting (tokens.css @media prefers-color-scheme). The button next to
// Sign out pins Light or Dark for this browser; that choice is a per-person
// convenience, so it lives in localStorage and a blocked store just means
// "follow the device".
export type Theme = 'light' | 'dark';
const KEY = 'nv-theme';

export function storedTheme(): Theme | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}

export function applyTheme(theme: Theme | null): void {
  const el = document.documentElement;
  if (theme) el.dataset.theme = theme;
  else delete el.dataset.theme;
}

/** What is on screen right now — the pinned choice, else the device's. */
export function currentTheme(): Theme {
  const pinned = document.documentElement.dataset.theme;
  if (pinned === 'light' || pinned === 'dark') return pinned;
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark' : 'light';
}

export function setTheme(theme: Theme): void {
  try { localStorage.setItem(KEY, theme); } catch { /* storage unavailable — still applies for this visit */ }
  applyTheme(theme);
}
